import { EDM } from '@bingads-webui/edm-core-legacy';
import { jsdataPlugin } from '@bingads-webui/edm-js-data';
import { odataPlugin } from '@bingads-webui/edm-odata-legacy';
import { resIdsPlugin } from '@bingads-webui/edm-resource-identifiers-legacy';
import {
  defineConstProperty,
  defineComputedProperty,
} from '@bingads-webui/reflection';
import _ from 'underscore';
import { getJsDataExtension } from './js-data-extension';

export const getEdmBhc = ({
  state, schemas, CustomerIdType, config,
}) => {
  if (!state || !schemas || !CustomerIdType || !config) {
    return {};
  }
  const namespace = 'Microsoft.BingAds.Api.Model.Travel';
  const edm = new EDM({
    schemas,
    namespace,
  });
  const jsdataExtension = getJsDataExtension({ config, state });

  resIdsPlugin(edm);
  odataPlugin(edm, '');
  jsdataPlugin(edm);

  jsdataExtension(edm);

  // Define the root type
  // We only have a Customer entity set at the root
  const rootType = new edm.types.ComplexType({
    name: '$ROOT',
    properties: {
      Customers: { typeName: `${namespace}.TravelCustomer@COLL` },
    },
  });
  const root = new rootType.ResourceIdentifier();

  defineConstProperty(edm, 'root', root);

  const customerIdType = new CustomerIdType();

  defineConstProperty(edm, 'customerIdType', customerIdType);

  _.each({
    currentCustomer: {
      key: 'customer_id',
      parent: 'root',
      collection: 'Customers',
    },
    currentAccount: {
      key: 'account_id',
      parent: 'currentCustomer',
      collection: 'Accounts',
    },
  }, (dependencies, name) => {
    defineComputedProperty(edm, name, () => {
      let id = state.get(dependencies.key);
      const parent = edm[dependencies.parent];

      if (edm.customerIdType.useAdvertiserCustomerId && dependencies.parent === 'root' && state.get('advertisercustomer_id')) {
        id = state.get('advertisercustomer_id');
      }

      return parent && id ? parent[dependencies.collection].$withKey(Number(id)) : null;
    });
  });
  return { jsdataBhc: edm.jsdata.resources };
};
